import $ from "jquery";
import { createNanoId, contentMeta, getDynData } from "#scripts/general_functions";
import { setResponsiveImage, getImageByContentId } from "#scripts/images";
import { campaigns, campaignItem, campaignItem2 } from "#templates/modules/campaigns_template";
import { getColorFromBGColor } from "#scripts/tools/textcolor.js";

export const getCampaigns = (load, from, moduleCardItemGuid, callback) => {
	let campaignsContentId = "4e159a34-1e45-413f-b053-a2bd9f843121"; // Forsidekampanje
	if (window.serverdata.configMeta.aim.template !== "frontpage") {
		campaignsContentId = "09ceb3f2-3b86-4a5f-a823-16c6210982bc"; // Kampanje (generell)
	}

	let apiLang = "nb_no";

	switch (window.serverdata.configMeta.aim.lang) {
		case "nb":
		case "nn":
			apiLang = `${window.serverdata.configMeta.aim.lang}_no`;
			break;
		case "en":
			apiLang = "en_us";
			break;
	}
	apiLang = localStorage.getItem("currentLanguage") || apiLang;

	const apiCall = `${window.apiUrl}/Public/articles`;
	const apiParametersArray = [];

	let ids = [];
	if (moduleCardItemGuid.includes(";")) {
		ids = moduleCardItemGuid.split(";");
	} else {
		ids.push(moduleCardItemGuid);
	}

	for (const id of ids) {
		if (id !== "") {
			apiParametersArray.push(
				`/${id}?subscriptionId=${window.serverdata.configMeta.aim.clientId}&language=${apiLang}&includeCategories=true&offset=${from}&limit=${load}&sortBy=Published&useSortIndex=true&getRecursiveContent=true&WrapAsList=true`,
			);
		} else {
			apiParametersArray.push(
				`?subscriptionId=${window.serverdata.configMeta.aim.clientId}&contentType=${campaignsContentId}&language=${apiLang}&includeCategories=true&offset=${from}&limit=${load}&sortBy=Published&useSortIndex=true&getRecursiveContent=true`,
			);
		}
	}

	Promise.all(apiParametersArray.map((apiParameters) => fetch(apiCall + apiParameters).then((response) => response.json())))
		.then((data) => {
			// Combine the listOfContent arrays from each response
			const combinedListOfContent = data.reduce((acc, current) => {
				return acc.concat(current.listOfContent);
			}, []);

			// Create the new JSON object
			const combinedData = {
				totalCount: combinedListOfContent.length,
				listOfContent: combinedListOfContent,
			};
			callback(combinedData);
		})
		.catch((error) => {
			// if there's an error, log it
			console.log(error);
		});
};

export const campaignsFront = (maxItems = 1, moduleCardItemGuid = null, campaignDesign = "", moduleCardColor = "") => {
	const moduleGuid = createNanoId();

	getCampaigns(maxItems, 0, moduleCardItemGuid, (data) => {
		const campaigns = [];
		let campCount = 0;

		if (data.totalCount > 0) {
			for (const campaign of data.listOfContent) {
				const meta = contentMeta(campaign);
				const details = meta !== undefined ? getDynData(meta) : "";
				const campGuid = createNanoId();
				const addThisItem = moduleCardItemGuid === "" || moduleCardItemGuid.includes(campaign.contentId);

				if (window.serverdata.configMeta.aim?.moduleSettings?.campaigns?.introNewline === true && (details.forsidetekst !== undefined || details.kampanjetekst !== undefined)) {
					details.forsidetekst = details.forsidetekst.replace(/\n/g, "<br>");
					details.kampanjetekst = details.kampanjetekst.replace(/\n/g, "<br>");
				}
				if (addThisItem && campCount < maxItems && (details.forsidetittel || details.kampanjetekst)) {
					let image = "";

					if (meta.imageContentId) {
						// hasImage = true;
						if (campaign.imagePath) {
							let ar = window.screen.availWidth > 691 ? ',ar_16:9' : ',ar_1:1';
							const focus = '';

							ar = window.serverdata.configMeta.aim?.style?.module?.campaign__image_width === window.serverdata.configMeta.aim?.style?.module?.campaign__image_height ? ",ar_1:1" : ar;
							// let { width, height } = getDimensions(me);
							// const [hotSpotX, hotSpotY] = hotSpot.split(",");
							// const x = data.input.width / 2 + (data.input.width / 2) * hotSpotX;
							// const y = data.input.height / 2 - (data.input.height / 2) * hotSpotY;
							// focus = `,g_xy_center,x_${Math.floor(x)},y_${Math.floor(y)}`;

							const imgUrl = campaign.imagePath.includes("preview.sdl.no") ? campaign.imagePath.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`) : campaign.imagePath;
							image = `<div class="campaign__image_container">
													<img src='//res.cloudinary.com/ssp/image/fetch/c_fill${ar}${focus}/c_limit,w_750/${imgUrl}' id='campaign_${campGuid}' class="campaign__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}">
											</div>`;
						} else {
							image = `<div class="campaign__image_container">
													<img src='' id='campaign_${campGuid}' class="campaign__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}">
											</div>`;
							getImageByContentId(meta.imageContentId, (img) => {
								$(`#campaign_${campGuid}`).attr({
									"data-src": img.url,
									src: "/images/transparent.png",
									"data-imagemode": "fill",
								});
								if (img.imageHotspotX !== undefined && img.imageHotspotY !== undefined) {
									$(`#campaign_${campGuid}`).attr({
										"data-imagehotspot": `${img.imageHotspotX},${img.imageHotspotY}`,
									});
								}
								setResponsiveImage($(`#campaign_${campGuid}`), window.screen.availWidth > 691 ? "16:9" : "1:1");
							});
						}
					}


					let link = `/artikkel/${campaign.nameInUrl}`;
					// let linktext = 'Les mer her';
					// let dynLink = getDynData(meta, "ea427bbd-f370-4f63-9769-2120a6a6fefd").res;
					const dynLink = getDynData(meta, "dddc6cac-9579-4d59-9f52-c3a85ca05473").res; // "Lenke fra forsideboks (valgfri)"
					const sortorder = details.sorteringsrekkefolge; // getDynData(meta, "sortorder").res;
					if (dynLink) {
						link = dynLink; // `<span class="campaign__link">Gå til siden</span>`;
						// linktext = language('CAMPAIGN_GOTOPAGE');
					}

					campCount++;
					campaigns.push({
						item: campaignItem({
							link,
							image,
							forsidetittel: details.forsidetittel || details.kampanjetittel || "",
							forsidetekst: details.forsidetekst || details.kampanjetekst || "",
							order: sortorder,
							color: moduleCardColor,
						}),
						order: sortorder,
					});
				}
			}
		}

		// if(sorting) {
		// campaigns.sort(function(a,b) => (a.))
		// }
		// const sortedCampaigns = campaigns.sort((a, b) => {
		//   if (a.order < b.order) return -1;
		//   if (a.order > b.order) return 1;
		//   return 0;
		// });

		// sortedCampaigns = sortedCampaigns.slice(0, maxItems);

		if (campaigns.length < 1) {
			$(`#campaigns_${moduleGuid}>div`).html("");
			$(`#campaigns_${moduleGuid}`).hide();
		} else {
			// campaigns = campaigns.join("");
			// $("#campaigns").html(campaigns.join(""));
			const joinedCampaigns = campaigns.map((e) => e.item).join("");
			$(`#campaigns_${moduleGuid}`).html(joinedCampaigns);
		}
		if (campaigns.length === 1) {
			$(`#campaigns_${moduleGuid}`).addClass("single");
		}
	});

	return campaigns({
		moduleID: moduleGuid,
		campaignDesign,
		maxItems,
	});
};

export const campaignsTheme = (maxItems = 1, moduleCardItemGuid = null, campaignDesign = "", campaignImagePos = "", moduleCardColor = "", moduleCardButtontext = "") => {
	const moduleGuid = createNanoId();

	getCampaigns(maxItems, 0, moduleCardItemGuid, (data) => {
		const campaigns = [];
		let campCount = 0;

		if (data.totalCount > 0) {
			for (const campaign of data.listOfContent) {
				const meta = contentMeta(campaign);
				const details = meta !== undefined ? getDynData(meta) : "";
				const campGuid = createNanoId();
				const addThisItem = moduleCardItemGuid === "" || moduleCardItemGuid.includes(campaign.contentId);

				if (window.serverdata.configMeta.aim?.moduleSettings?.campaigns?.introNewline === true && (details.forsidetekst !== undefined || details.kampanjetekst !== undefined)) {
					details.forsidetekst = details.forsidetekst.replace(/\n/g, "<br>");
					details.kampanjetekst = details.kampanjetekst.replace(/\n/g, "<br>");
				}
				if (addThisItem && campCount < maxItems && (details.forsidetittel || details.kampanjetittel)) {
					let image = "";

					if (meta.imageContentId) {
						if (campaign.imagePath) {
							let ar = window.screen.availWidth > 691 ? ',ar_16:9' : ',ar_1:1';
							const focus = '';

							ar = window.serverdata.configMeta.aim?.style?.module?.campaign__image_width === window.serverdata.configMeta.aim?.style?.view?.theme__module__campaign__medium__image_height ? ",ar_1:1" : ar;
							//check if aspect ratio should be 1:1 for campaigns
							// let { width, height } = getDimensions(me);
							// const [hotSpotX, hotSpotY] = hotSpot.split(",");
							// const x = data.input.width / 2 + (data.input.width / 2) * hotSpotX;
							// const y = data.input.height / 2 - (data.input.height / 2) * hotSpotY;
							// focus = `,g_xy_center,x_${Math.floor(x)},y_${Math.floor(y)}`;

							const imgUrl = campaign.imagePath.includes("preview.sdl.no") ? campaign.imagePath.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`) : campaign.imagePath;
							image = `<div class="campaign__image_container">
													<img src='//res.cloudinary.com/ssp/image/fetch/c_fill${ar}${focus}/c_limit,w_750/${imgUrl}' id='campaign_${campGuid}' class="campaign__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}">
											</div>`;
						} else {
							image = `<div class="campaign__image_container">
												<img src='/images/transparent.png' id='campaign_${campGuid}' class="campaign__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}" >
										</div>`;
							getImageByContentId(meta.imageContentId, (img) => {
								$(`#campaign_${campGuid}`).attr({
									"data-src": img.url,
									"data-imagemode": "fill",
								});
								if (img.imageHotspotX !== undefined && img.imageHotspotY !== undefined) {
									$(`#campaign_${campGuid}`).attr({
										"data-imagehotspot": `${img.imageHotspotX},${img.imageHotspotY}`,
									});
								}
								setResponsiveImage($(`#campaign_${campGuid}`), window.screen.availWidth > 691 ? "16:9" : "1:1");
							});
						}
					}

					let link = `/artikkel/${campaign.nameInUrl}`;
					// const dynLink = getDynData(meta, "dddc6cac-9579-4d59-9f52-c3a85ca05473").res; //forsidekampanje lenke
					const dynLink = getDynData(meta, "86f9e817-0a00-494b-bc81-0129840ab636").res; //kampanje lenke
					const sortorder = details.sorteringsrekkefolge;
					if (dynLink) {
						link = dynLink;
					}

					campCount++;
					campaigns.push({
						item: campaignItem2({
							link,
							image,
							forsidetittel: details.forsidetittel || details.kampanjetittel || "",
							forsidetekst: details.forsidetekst || details.kampanjetekst || "",
							order: sortorder,
							bgcolor: moduleCardColor,
							color: getColorFromBGColor(moduleCardColor || "var(--text__black)"),
							campaignDesign,
							moduleCardButtontext

						}),
						order: sortorder,
					});
				}
			}
		}

		if (campaigns.length < 1) {
			$(`#campaigns_${moduleGuid}>div`).html("");
			$(`#campaigns_${moduleGuid}`).hide();
		} else {
			const joinedCampaigns = campaigns.map((e) => e.item).join("");
			$(`#campaigns_${moduleGuid}`).html(joinedCampaigns);
		}
		if (campaigns.length === 1) {
			$(`#campaigns_${moduleGuid}`).addClass("single");
		}
	});

	return campaigns({
		moduleID: moduleGuid,
		campaignDesign,
		campaignImagePos,
		maxItems,
	});
};
